import React from 'react'
import PropTypes from 'prop-types'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { formatDate, formatDollarsWithSymbol } from '../../utils/functions'
import { DATE_FORMAT } from '../../utils/constants'

const Gap = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: 0,
  height: 23,
  backgroundColor: '#FFFFFF',
  zIndex: 12,
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}))

const TableHeadContainer = styled(TableContainer)(({ theme }) => ({
  overflowX: 'unset',
  maxWidth: '350px',
  [theme.breakpoints.down('sm')]: {
    overflowX: 'auto',
  },
}))

const StyledTable = styled(Table)(({ theme }) => ({}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  position: 'sticky',
  top: 23,
  [theme.breakpoints.down('sm')]: {
    top: 0,
  },
}))

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  border: 'none',
  fontFamily: 'Poppins, sans-serif',
  fontSize: '16px',
  padding: '16px !important',
  [theme.breakpoints.down('xs')]: {
    fontSize: '14px',
  },
}))

const NoBorderTableCell = styled(TableCell)(({ theme }) => ({
  border: 'none',
  boxShadow: '0px 1px rgba(0, 0, 0, 0.16)',
  padding: '16px !important',
}))

const inlineTableStyles = {
  display: 'flex',
  justifyContent: 'right',
}

const PriceHistorySearchTable = ({ page }) => {
  return (
    <>
      <Gap />
      <TableHeadContainer>
        <StyledTable aria-label="Price History Table" role="presentation">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Date</StyledTableCell>
              <StyledTableCell align="right">Price (NAV)</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {page.map((item) => (
              <TableRow key={item.date}>
                <NoBorderTableCell>
                  <Typography variant="body2">
                    {formatDate(item.date, DATE_FORMAT)}
                  </Typography>
                </NoBorderTableCell>
                <NoBorderTableCell sx={inlineTableStyles}>
                  <Typography variant="body2">
                    {formatDollarsWithSymbol(item.nav)}
                  </Typography>
                </NoBorderTableCell>
              </TableRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableHeadContainer>
    </>
  )
}

PriceHistorySearchTable.propTypes = {
  page: PropTypes.any,
}

export default PriceHistorySearchTable
